var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Grid, Icon, Label, Menu } from "semantic-ui-react";
import { Channel, Plexity, ProKitConfig } from "../../KitDeserializer";
import { postJsonWithAuthn } from "../../RequestHelpers";
import { findChromogenPresetScale, findDetectPresetScale, findProbePresetScale } from "../manual-pro/ManualProConsumerDetectForm";
import { PriceDisplay } from "../rna-fish/EditKitForm";
import { ErrorElementsWithPrices } from "../rna-fish/NewRnaFishKitPage";
import { uniqueBy } from "../rna-fish/ProbeSetForm";
import MultiplexKitSerializer from "./MultiplexKitSerializer";
import { defaultProKitDetectFormState, defaultProKitProbeFormState } from "./NewMultiPlexProKitPage";
import ProKitDetectForm, { checkChromogenCompatibility } from "./ProKitDetectForm";
import ProKitProbeForm from "./ProKitProbeForm";
var EditKitForm = /** @class */ (function (_super) {
    __extends(EditKitForm, _super);
    function EditKitForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onConfigurationChange = function (_, data) {
            var index = data.index;
            var kitConfiguration = _this.props.kitConfigurations[index];
            _this.props.setFormState(function () {
                return {
                    kitConfiguration: kitConfiguration
                };
            }, _this.loadPrice);
        };
        _this.onPlatformChange = function (_, data) {
            var pt = data.name;
            var selectedPlatform = _this.props.catalog.proPlatforms.find(function (p) {
                return p.id === pt;
            });
            // If the newPlatform is not Discovery then switch the prefilled status to false
            var prefilled = _this.props.formState.prefilled;
            if ((selectedPlatform === null || selectedPlatform === void 0 ? void 0 : selectedPlatform.id) !== ProtocolTypeEnum.ROCHE) {
                prefilled = false;
            }
            // If the newPlatform is Discovery and scale is 90 then set prefilled to true
            if ((selectedPlatform === null || selectedPlatform === void 0 ? void 0 : selectedPlatform.id) === ProtocolTypeEnum.ROCHE && _this.props.formState.scale === 90) {
                prefilled = true;
            }
            var ampCatalog = _this.getAmpCatalog(_this.props.formState.addedSecondTarget);
            var probeAmps = getProbeAmps(ampCatalog, selectedPlatform);
            var enzymes = _this.getSelectedEnzyme(ampCatalog, selectedPlatform);
            _this.props.setFormState(function (oldFormState) {
                return __assign(__assign({}, oldFormState), { protocolType: selectedPlatform, amplifierCatalog: ampCatalog, prefilled: prefilled, proKitProbeState: _this.newProbeSetState(undefined, probeAmps, undefined, selectedPlatform, _this.props.formState.plexity), proKitDetectState: _this.newDetectState(selectedPlatform, enzymes), detectPresetScale: _this.detectPresetScale(undefined, selectedPlatform, undefined), chromogenPresetScale: _this.chromogenPresetScale(undefined, selectedPlatform, undefined) });
            }, _this.loadPrice);
        };
        _this.onScaleChange = function (_, data) {
            var index = data.index;
            var selectedScale = _this.props.catalog.automatedProScaleOptions[index];
            var newProbeState = _this.newProbeSetState(undefined, undefined, selectedScale, undefined, undefined);
            _this.props.setFormState(function (oldFormState) {
                return __assign(__assign({}, oldFormState), { scale: selectedScale, proKitProbeState: newProbeState, detectPresetScale: _this.detectPresetScale(selectedScale, undefined, undefined), chromogenPresetScale: _this.chromogenPresetScale(selectedScale, undefined, undefined) });
            }, function () {
                var _a;
                if (((_a = _this.props.formState.protocolType) === null || _a === void 0 ? void 0 : _a.id) === ProtocolTypeEnum.ROCHE) {
                    if (selectedScale === 90) {
                        _this.props.setFormState(function () {
                            return {
                                prefilled: true
                            };
                        }, _this.loadPrice);
                    }
                    else {
                        _this.props.setFormState(function () {
                            return {
                                prefilled: false
                            };
                        }, _this.loadPrice);
                    }
                }
                else {
                    _this.loadPrice();
                }
            });
        };
        _this.onProbeStateChange = function (updateObjOrFn, channel, callback) {
            _this.props.setFormState(function (oldState) {
                var newState = oldState.proKitProbeState
                    .map(function (pss) {
                    if (channel && channel === pss.channel) {
                        var setState = void 0;
                        if (typeof updateObjOrFn === "function") {
                            setState = updateObjOrFn(pss.state);
                        }
                        else {
                            setState = updateObjOrFn;
                        }
                        var newProbeSetState = {
                            state: __assign(__assign({}, pss.state), setState),
                            channel: channel,
                            metadata: pss.metadata
                        };
                        return Object.assign({}, pss, newProbeSetState);
                    }
                    else {
                        return pss;
                    }
                });
                return {
                    proKitProbeState: _this.newProbeSetState(newState, undefined, undefined, undefined, undefined)
                };
            }, function (newState) {
                if (callback) {
                    callback(newState);
                }
            });
        };
        _this.onDetectStateChange = function (updateObjOrFn, channel, callback) {
            _this.props.setFormState(function (oldState) {
                var newState = oldState.proKitDetectState
                    .map(function (dss) {
                    if (channel && channel === dss.channel) {
                        var setState = void 0;
                        if (typeof updateObjOrFn === "function") {
                            setState = updateObjOrFn(dss.state);
                        }
                        else {
                            setState = updateObjOrFn;
                        }
                        var newDetectState = {
                            state: __assign(__assign({}, dss.state), setState),
                            channel: channel,
                            metadata: dss.metadata
                        };
                        return Object.assign({}, dss, newDetectState);
                    }
                    else {
                        return dss;
                    }
                });
                return {
                    proKitDetectState: newState,
                    detectPresetScale: _this.detectPresetScale(undefined, undefined, undefined),
                    chromogenPresetScale: _this.chromogenPresetScale(undefined, undefined, newState[0].state.chromogen)
                };
            }, function (newState) {
                if (callback) {
                    callback(newState);
                }
            });
        };
        _this.onPrefilledChange = function (_, data) {
            var index = data.index;
            _this.props.setFormState(function () { return ({
                prefilled: index === 1
            }); }, _this.loadPrice);
        };
        _this.getSelectedEnzyme = function (ampCatalog, platform) {
            var enzymeCompatibility = _this.props.formState.proKitDetectState.map(function (d) {
                return {
                    data: d.state.enzymeCompatibility,
                    channel: d.channel
                };
            });
            return ampCatalog
                .proAmpConfigList
                .filter(function (c) {
                var _a;
                var selectedEnzyme = (_a = enzymeCompatibility === null || enzymeCompatibility === void 0 ? void 0 : enzymeCompatibility.find(function (e) { return (e.channel === c.channelNum); })) === null || _a === void 0 ? void 0 : _a.data;
                return c.label === (selectedEnzyme === null || selectedEnzyme === void 0 ? void 0 : selectedEnzyme.label) &&
                    c.platformCompatibility.find(function (pc) { return pc.id === (platform === null || platform === void 0 ? void 0 : platform.id); }) != null;
            }).map(function (e) {
                return {
                    data: e,
                    channel: e.channelNum
                };
            }).sort(function (c1, c2) {
                return c1.channel - c2.channel;
            });
        };
        _this.onAddSecondTarget = function () {
            var _a, _b, _c;
            // Only one of these variables is necessary
            var addedSecondTarget = !_this.props.formState.addedSecondTarget;
            var plexity = _this.props.formState.addedSecondTarget ? Plexity.OnePlex : Plexity.TwoPlex;
            var platform;
            // if we added a second target then switch over to the first compatible newPlatform with the config.
            if (addedSecondTarget) {
                platform = (_a = _this.props.catalog.proPlatforms
                    .find(function (pc) { var _a; return pc.plexity.includes(plexity) && pc.id === ((_a = _this.props.formState.protocolType) === null || _a === void 0 ? void 0 : _a.id); })) !== null && _a !== void 0 ? _a : _this.props.catalog.proPlatforms
                    .find(function (pc) { return pc.plexity.includes(plexity); });
            }
            else {
                platform = _this.props.formState.protocolType;
            }
            var ampCatalog = _this.getAmpCatalog(addedSecondTarget);
            var probeAmps = getProbeAmps(ampCatalog, platform);
            var enzymes = _this.getSelectedEnzyme(ampCatalog, platform);
            var newProbeState = _this.newProbeSetState(undefined, probeAmps, undefined, platform, plexity);
            var newDetectState = _this.newDetectState(platform, enzymes);
            var newDetectPresetScales = _this.props.formState.detectPresetScale;
            if (addedSecondTarget) {
                var amp = (_c = (_b = probeAmps
                    .find(function (a) { return (a.channel === Channel.Channel2); })) === null || _b === void 0 ? void 0 : _b.data) !== null && _c !== void 0 ? _c : probeAmps[0].data;
                var presetScale = _this.probePresetScale(undefined, undefined, undefined, plexity, Channel.Channel2);
                newProbeState = newProbeState.concat([{
                        state: defaultProKitProbeFormState(amp),
                        channel: Channel.Channel2,
                        metadata: presetScale
                    }]);
                newDetectState = newDetectState.concat([
                    {
                        state: defaultProKitDetectFormState(),
                        channel: Channel.Channel2,
                        metadata: undefined
                    }
                ]);
                newDetectPresetScales = _this.detectPresetScale(undefined, undefined, Plexity.TwoPlex);
            }
            else {
                newProbeState = newProbeState.slice(0, 1);
                newDetectState = newDetectState.slice(0, 1);
                newDetectPresetScales = _this.detectPresetScale(undefined, undefined, plexity);
            }
            _this.props.setFormState(function () {
                return {
                    addedSecondTarget: addedSecondTarget,
                    amplifierCatalog: ampCatalog,
                    protocolType: platform,
                    plexity: plexity,
                    proKitProbeState: newProbeState,
                    proKitDetectState: newDetectState,
                    detectPresetScale: newDetectPresetScales
                };
            }, _this.loadPrice);
        };
        _this.getAmpCatalog = function (addedSecondTarget) {
            var amplifierCatalog = _this.props.catalog.proAmplifier;
            var ampCatalog;
            if (addedSecondTarget) {
                ampCatalog = amplifierCatalog.twoTargetProAmps;
            }
            else {
                ampCatalog = amplifierCatalog.oneTargetProAmps;
            }
            return ampCatalog;
        };
        _this.loadPrice = function () {
            _this.props.setFormState(function () { return ({ priceLoading: true }); }, function (newState) {
                var kitBody = EditKitForm.serializeMultiPlexProKit(newState);
                postJsonWithAuthn(_this.props.kitPriceUrlPath, JSON.stringify(kitBody))
                    .then(function (resp) {
                    if (resp.status === 400) {
                        return resp.json().then(function (json) { return new ErrorElementsWithPrices(json.errors, json.price); });
                    }
                    return resp.json();
                }).then(function (resp) {
                    if (resp instanceof ErrorElementsWithPrices) {
                        _this.props.setFormState(function () { return ({
                            errors: resp.errors,
                            priceLoading: false,
                            price: resp.price
                        }); });
                    }
                    else {
                        _this.props.setFormState(function () { return ({
                            errors: [],
                            price: resp,
                            priceLoading: false
                        }); });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't update price: " + rej);
                });
            });
        };
        _this.variants = function () {
            return _this.props.formState.proKitProbeState
                .sort(function (s1, s2) {
                return s1.channel - s2.channel;
            })
                .map(function (pss) {
                var variant;
                _this.props.catalog.probeSet.catalog.organisms.forEach(function (o) {
                    o.probeSetFamilies.forEach(function (psf) {
                        psf.variants.forEach(function (v) {
                            var _a;
                            if (v.id === ((_a = pss.state.target) === null || _a === void 0 ? void 0 : _a.variantId)) {
                                variant = v;
                            }
                        });
                    });
                });
                return {
                    data: variant,
                    channel: pss.channel
                };
            });
        };
        _this.probePresetScale = function (variant, newScale, newPlatform, newPlexity, channel) {
            var _a, _b, _c;
            return findProbePresetScale(_this.props.catalog.presetScales, ((_a = newPlatform === null || newPlatform === void 0 ? void 0 : newPlatform.id) !== null && _a !== void 0 ? _a : (_b = _this.props.formState.protocolType) === null || _b === void 0 ? void 0 : _b.id), variant, (_c = newScale !== null && newScale !== void 0 ? newScale : _this.props.formState.scale) !== null && _c !== void 0 ? _c : _this.props.catalog.defaultAutomatedProScale, newPlexity !== null && newPlexity !== void 0 ? newPlexity : _this.props.formState.plexity, channel);
        };
        _this.detectPresetScale = function (newScale, newPlatform, newPlexity) {
            var _a, _b, _c;
            return findDetectPresetScale(_this.props.catalog.presetScales, ((_a = newPlatform === null || newPlatform === void 0 ? void 0 : newPlatform.id) !== null && _a !== void 0 ? _a : (_b = _this.props.formState.protocolType) === null || _b === void 0 ? void 0 : _b.id), (_c = newScale !== null && newScale !== void 0 ? newScale : _this.props.formState.scale) !== null && _c !== void 0 ? _c : _this.props.catalog.defaultAutomatedProScale, newPlexity !== null && newPlexity !== void 0 ? newPlexity : (_this.props.formState.addedSecondTarget ? Plexity.TwoPlex : Plexity.OnePlex), false);
        };
        _this.chromogenPresetScale = function (newScale, newPlatform, newChromogen) {
            var _a, _b, _c, _d;
            var chromogenPresetScale;
            if (_this.props.formState.proKitDetectState.length === 1) {
                chromogenPresetScale = findChromogenPresetScale(_this.props.catalog.presetScales, ((_a = newPlatform === null || newPlatform === void 0 ? void 0 : newPlatform.id) !== null && _a !== void 0 ? _a : (_b = _this.props.formState.protocolType) === null || _b === void 0 ? void 0 : _b.id), (_c = newChromogen !== null && newChromogen !== void 0 ? newChromogen : _this.props.formState.proKitDetectState[0].state.chromogen) !== null && _c !== void 0 ? _c : undefined, (_d = newScale !== null && newScale !== void 0 ? newScale : _this.props.formState.scale) !== null && _d !== void 0 ? _d : _this.props.catalog.defaultAutomatedProScale);
            }
            return chromogenPresetScale;
        };
        _this.newProbeSetState = function (newProbeState, newProbeAmps, newScale, newPlatform, plexity) {
            return (newProbeState !== null && newProbeState !== void 0 ? newProbeState : _this.props.formState.proKitProbeState)
                .sort(function (s1, s2) {
                return s1.channel - s2.channel;
            })
                .map(function (pss) {
                var _a;
                var amp = (_a = newProbeAmps === null || newProbeAmps === void 0 ? void 0 : newProbeAmps.find(function (a) { return (a.channel === pss.channel); })) === null || _a === void 0 ? void 0 : _a.data;
                var variant = _this.variants().find(function (v) {
                    var _a, _b;
                    return ((_a = v.data) === null || _a === void 0 ? void 0 : _a.id) === ((_b = pss.state.target) === null || _b === void 0 ? void 0 : _b.variantId);
                });
                var presetScale = _this.probePresetScale(variant === null || variant === void 0 ? void 0 : variant.data, newScale, newPlatform, plexity, pss.channel);
                return {
                    state: __assign(__assign({}, pss.state), { hcrAmplifier: amp !== null && amp !== void 0 ? amp : pss.state.hcrAmplifier }),
                    channel: pss.channel,
                    metadata: presetScale
                };
            });
        };
        _this.newDetectState = function (selectedPlatform, enzymes) {
            return _this.props.formState.proKitDetectState
                .sort(function (s1, s2) {
                return s1.channel - s2.channel;
            })
                .map(function (dss) {
                var _a;
                var enzyme = (_a = enzymes.find(function (e) {
                    return e.channel === dss.channel;
                })) === null || _a === void 0 ? void 0 : _a.data;
                if (!checkChromogenCompatibility(dss.state.chromogen, selectedPlatform, enzyme)) {
                    return {
                        state: __assign(__assign({}, dss), { enzymeCompatibility: enzyme, chromogen: undefined }),
                        channel: dss.channel,
                        metadata: dss.metadata
                    };
                }
                else {
                    return {
                        state: __assign(__assign({}, dss), { enzymeCompatibility: enzyme }),
                        channel: dss.channel,
                        metadata: dss.metadata
                    };
                }
            });
        };
        return _this;
    }
    EditKitForm.prototype.render = function () {
        var _this = this;
        // const ampCatalog = this.props.formState.amplifierCatalog
        var scale = this.props.formState.scale;
        var kitConfigurations = this.props.kitConfigurations;
        var protocols = this.props.catalog.proPlatforms;
        var kitConfiguration = this.props.formState.kitConfiguration;
        var protocolType = this.props.formState.protocolType;
        var probeDisabled = (kitConfiguration === ProKitConfig.DetectOnly || kitConfiguration == null);
        var detectDisabled = (kitConfiguration === ProKitConfig.ProbeOnly || kitConfiguration == null);
        var detect1Amps = this.props.formState.amplifierCatalog.proAmpConfigList
            .filter(function (c) {
            return c.channelNum === Channel.Channel1;
        });
        var detect2Amps = this.props.formState.amplifierCatalog.proAmpConfigList
            .filter(function (c) {
            return c.channelNum === Channel.Channel2;
        });
        var channel1Label;
        var channel2Label;
        var addChannelLabel;
        if (kitConfiguration === ProKitConfig.ProbeDetect
            || kitConfiguration === ProKitConfig.ProbeOnly
            || kitConfiguration === ProKitConfig.StarterKitProbe) {
            if (this.props.formState.plexity === Plexity.TwoPlex) {
                channel1Label = "Target 1";
                channel2Label = "Target 2";
                addChannelLabel = "remove target for 1-plex";
            }
            else {
                channel1Label = "Target";
                channel2Label = "";
                addChannelLabel = "add target for 2-plex";
            }
        }
        else {
            if (this.props.formState.plexity === Plexity.TwoPlex) {
                channel1Label = "Channel 1";
                channel2Label = "Channel 2";
                addChannelLabel = "remove channel for 1-plex";
            }
            else {
                channel1Label = "Channel";
                channel2Label = "";
                addChannelLabel = "add channel for 2-plex";
            }
        }
        return React.createElement(React.Fragment, null,
            React.createElement(Grid, { columns: 2, verticalAlign: "middle" },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3 }),
                    React.createElement(Grid.Column, { textAlign: "center", width: 12 },
                        React.createElement("h1", { className: "ish-primary-header" }, "HCR\u2122 Kit Designer"),
                        React.createElement("h1", { className: "ish-subheader" }, "Build your RNA-ISH Kit")))),
            React.createElement(Grid, { columns: 4, verticalAlign: "middle" },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("p", { className: "ish-subheader-tag" }, "Configuration")),
                    React.createElement(Grid.Column, { width: 12, textAlign: "center" },
                        React.createElement(Menu, { compact: true, widths: 12, className: 'outer-config-box', borderless: true }, kitConfigurations.map(function (bc, index) {
                            return React.createElement(React.Fragment, { key: index },
                                bc === ProKitConfig.ProbeDetect && React.createElement(Menu.Item, { className: kitConfiguration === bc ?
                                        "configure-selection selected-ish" : "configure-selection", onClick: _this.onConfigurationChange, index: index, fitted: true, active: kitConfiguration === bc },
                                    React.createElement("p", { className: kitConfiguration === bc ? "ish-p-tag selected-ish" : "ish-p-tag" },
                                        "Probe + Detect",
                                        React.createElement("br", null),
                                        "Kit")),
                                bc === ProKitConfig.ProbeOnly && React.createElement(Menu.Item, { className: kitConfiguration === bc ?
                                        "configure-selection selected-ish" : "configure-selection", onClick: _this.onConfigurationChange, index: index, fitted: true, active: kitConfiguration === bc },
                                    React.createElement("p", { className: kitConfiguration === bc ? "ish-p-tag selected-ish" : "ish-p-tag" },
                                        "Probe",
                                        React.createElement("br", null),
                                        "Only")),
                                bc === ProKitConfig.DetectOnly && React.createElement(Menu.Item, { className: kitConfiguration === bc ? "configure-selection selected-ish" : "configure-selection", onClick: _this.onConfigurationChange, index: index, fitted: true, active: kitConfiguration === bc },
                                    React.createElement("p", { className: kitConfiguration === bc ? "ish-p-tag selected-ish" : "ish-p-tag" },
                                        "Detect",
                                        React.createElement("br", null),
                                        "Only")));
                        })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("p", { className: 'ish-subheader-tag' }, "Platform")),
                    React.createElement(Grid.Column, { width: 12, textAlign: "center" },
                        React.createElement(Menu, { compact: true, widths: 12, className: "outer-config-box", borderless: true }, protocols
                            .filter(function (p) { return p.id !== ProtocolTypeEnum.MANUAL; })
                            .map(function (p, index) {
                            return React.createElement(React.Fragment, { key: index },
                                React.createElement(Menu.Item, { className: (p.plexity.includes(_this.props.formState.plexity)) ?
                                        ((protocolType === null || protocolType === void 0 ? void 0 : protocolType.id) === p.id ? "quarter-configure-selection selected-ish" : "quarter-configure-selection") :
                                        "quarter-configure-selection disabled-cr", onClick: _this.onPlatformChange, index: index, fitted: true, active: (protocolType === null || protocolType === void 0 ? void 0 : protocolType.id) === p.id, name: p.id },
                                    p.newLabel &&
                                        React.createElement(Label, { as: 'a', color: 'red', attached: "top right" },
                                            React.createElement("em", null, "New!")),
                                    React.createElement("p", { className: (protocolType === null || protocolType === void 0 ? void 0 : protocolType.id) === p.id ? "ish-p-tag selected-ish" : "ish-p-tag" },
                                        p.alias === "ONCORE Pro X" ?
                                            React.createElement(React.Fragment, null, "ONCORE Pro\u00A0X") : p.alias,
                                        React.createElement("br", null),
                                        (!p.plexity.includes(_this.props.formState.plexity)
                                            && protocolType != null)
                                            && "2-plex Coming Soon!")));
                        })))),
                (protocolType === null || protocolType === void 0 ? void 0 : protocolType.id) === ProtocolTypeEnum.BOND_III ? React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3 }),
                    React.createElement(Grid.Column, { width: 12, textAlign: "center" },
                        "We've recently launched fully ambient-temperature HCR\u2122 Pro RNA-ISH! Contact ",
                        React.createElement("a", { href: "mailto:info@molecularinstruments.com?subject=" + encodeURIComponent("Interested in fully ambient-temperature HCR™ Pro RNA-ISH") }, "us"),
                        " to get started.")) : React.createElement(React.Fragment, null,
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                            React.createElement("p", { className: 'ish-subheader-tag' }, "Scale")),
                        React.createElement(Grid.Column, { width: 12, textAlign: "center" },
                            React.createElement(Menu, { compact: true, widths: 12, className: "outer-config-box", borderless: true }, this.props.catalog.automatedProScaleOptions.map(function (s, index) {
                                return React.createElement(React.Fragment, { key: index },
                                    React.createElement(Menu.Item, { className: s === scale ? "half-configure-selection selected-ish" : "half-configure-selection", onClick: _this.onScaleChange, index: index, fitted: true, active: scale === s },
                                        React.createElement("p", { className: scale === s ? "ish-p-tag selected-ish" : "ish-p-tag" },
                                            s,
                                            " Slides")));
                            })))),
                    (protocolType === null || protocolType === void 0 ? void 0 : protocolType.id) === ProtocolTypeEnum.ROCHE
                        && kitConfiguration !== ProKitConfig.ProbeOnly
                        && scale && React.createElement(React.Fragment, null,
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                                React.createElement("p", { className: 'ish-subheader-tag' }, "Format")),
                            React.createElement(Grid.Column, { width: 12, textAlign: "center" },
                                React.createElement(Menu, { compact: true, widths: 12, className: "outer-config-box", borderless: true }, (this.props.formState.scale === 20 || this.props.formState.scale == null) ?
                                    React.createElement(React.Fragment, null,
                                        React.createElement(Menu.Item, { className: (!this.props.formState.prefilled && this.props.formState.scale != null)
                                                ? "half-configure-selection selected-ish" : "half-configure-selection", onClick: this.onPrefilledChange, fitted: true, active: !this.props.formState.prefilled, index: 0 },
                                            React.createElement("p", { className: !this.props.formState.prefilled ? "ish-p-tag selected-ish" : "ish-p-tag" }, "Reagents Only")),
                                        React.createElement(Menu.Item, { className: this.props.formState.prefilled ? "half-configure-selection selected-ish" : "half-configure-selection", onClick: this.onPrefilledChange, fitted: true, active: this.props.formState.prefilled, index: 1 },
                                            React.createElement("p", { className: this.props.formState.prefilled ? "ish-p-tag selected-ish" : "ish-p-tag" }, "Ready-to-Use in Dispensers"))) : React.createElement(React.Fragment, null,
                                    React.createElement(Menu.Item, { className: this.props.formState.prefilled ? "full-configure-selection selected-ish" : "full-configure-selection", onClick: this.onPrefilledChange, fitted: true, active: this.props.formState.prefilled, index: 1 },
                                        React.createElement("p", { className: this.props.formState.prefilled ? "ish-p-tag selected-ish" : "ish-p-tag" }, "Ready-to-Use in Dispensers")))))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: 3 }),
                            React.createElement(Grid.Column, { width: 12, textAlign: "center" },
                                "We\u2019ve recently launched pre-filled dispensers! Learn more ",
                                React.createElement("a", { target: "_blank", href: "https://www.hcrimaging.com/articles/rtu-dispensers" }, "here"),
                                "."))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { textAlign: "right", width: 3 },
                            React.createElement("h1", { className: 'ish-secondary-header' }, channel1Label))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: "16" },
                            React.createElement(ProKitProbeForm, { catalog: this.props.catalog, disabled: probeDisabled, channel: 1, errors: this.props.formState.errors, proKitProbeState: this.props.formState.proKitProbeState[0].state, onProProbeStateChange: this.onProbeStateChange, onUserSelection: this.loadPrice, protocolType: this.props.formState.protocolType }))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: "16" },
                            React.createElement(ProKitDetectForm, { protocolType: this.props.formState.protocolType, plexity: this.props.formState.plexity, channel: 1, kitConfiguration: this.props.formState.kitConfiguration, catalog: this.props.catalog, proAmps: detect1Amps, disabled: detectDisabled, errors: this.props.formState.errors, proKitDetectState: this.props.formState.proKitDetectState[0].state, onProDetectStateChange: this.onDetectStateChange, onUserSelection: this.loadPrice }))),
                    protocolType != null && [ProtocolTypeEnum.ROCHE, ProtocolTypeEnum.LEICA, ProtocolTypeEnum.ONCORE_PRO_X].includes(protocolType.id)
                        && React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { textAlign: "right", width: "15" },
                                React.createElement("a", { onClick: this.onAddSecondTarget, className: "second-target-text", style: {} },
                                    React.createElement(Icon, { name: this.props.formState.addedSecondTarget ? 'minus' : 'plus' }),
                                    addChannelLabel))),
                    this.props.formState.addedSecondTarget && React.createElement(React.Fragment, null,
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { textAlign: "right", width: 3 },
                                React.createElement("h1", { className: 'ish-secondary-header' }, channel2Label))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: "16" },
                                React.createElement(ProKitProbeForm, { catalog: this.props.catalog, disabled: probeDisabled, channel: 2, errors: this.props.formState.errors, proKitProbeState: this.props.formState.proKitProbeState[1].state, onProProbeStateChange: this.onProbeStateChange, onUserSelection: this.loadPrice, protocolType: this.props.formState.protocolType }))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: "16" },
                                React.createElement(ProKitDetectForm, { protocolType: this.props.formState.protocolType, kitConfiguration: this.props.formState.kitConfiguration, plexity: this.props.formState.plexity, channel: 2, catalog: this.props.catalog, proAmps: detect2Amps, disabled: detectDisabled, errors: this.props.formState.errors, proKitDetectState: this.props.formState.proKitDetectState[1].state, onProDetectStateChange: this.onDetectStateChange, onUserSelection: this.loadPrice })))))),
            React.createElement(Grid, { columns: 4, textAlign: "right" },
                React.createElement(Grid.Row, null,
                    React.createElement("br", null)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3 }),
                    React.createElement(Grid.Column, { width: 12 },
                        React.createElement("div", { 
                            // apply padding that matches the kit component div padding
                            style: { 'paddingRight': '.5rem' } },
                            React.createElement(PriceDisplay, { loading: this.props.formState.priceLoading, priceCents: this.props.formState.price ? this.props.formState.price.effectivePrice.subtotalCents : undefined }))))));
    };
    EditKitForm.prototype.componentDidMount = function () {
        if (this.props.loadPriceOnMount) {
            this.loadPrice();
        }
    };
    EditKitForm.serializeMultiPlexProKit = function (state) {
        var plexity = state.plexity;
        var config = state.kitConfiguration;
        var protocolType = state.protocolType;
        var scale = state.scale;
        var comment = state.comment;
        var serializer = new MultiplexKitSerializer(comment, plexity, state.prefilled, protocolType, config, scale, state.detectPresetScale, state.chromogenPresetScale);
        if (config === ProKitConfig.ProbeDetect) {
            serializer.setProbeSetState(state.proKitProbeState);
            serializer.setDetectState(state.proKitDetectState);
        }
        else if (config === ProKitConfig.ProbeOnly) {
            serializer.setProbeSetState(state.proKitProbeState);
        }
        else if (config === ProKitConfig.DetectOnly) {
            serializer.setDetectState(state.proKitDetectState);
        }
        return serializer.serializeKit();
    };
    return EditKitForm;
}(React.PureComponent));
export default EditKitForm;
export var debounce = function (fn, ms) {
    var timeoutId;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () { return fn.apply(_this, args); }, ms);
    };
};
export var cleanUpIshRnaSeq = function (s) {
    return s.toUpperCase()
        .replace(/[^ACGUTN]/g, '')
        .replace(/G/g, 'g')
        .replace(/T/g, 'U')
        .replace(/\s/g, '');
};
export var ProtocolTypeEnum;
(function (ProtocolTypeEnum) {
    ProtocolTypeEnum["LEICA"] = "LEICA";
    ProtocolTypeEnum["BOND_III"] = "BOND_III";
    ProtocolTypeEnum["NEOPATH_PRO"] = "NEOPATH_PRO";
    ProtocolTypeEnum["ROCHE"] = "ROCHE";
    ProtocolTypeEnum["ONCORE_PRO_X"] = "ONCORE_PRO_X";
    ProtocolTypeEnum["MANUAL"] = "MANUAL";
})(ProtocolTypeEnum || (ProtocolTypeEnum = {}));
export var ChromogenTypeEnum;
(function (ChromogenTypeEnum) {
    ChromogenTypeEnum["MATISSE_BROWN"] = "MATISSE_BROWN";
    ChromogenTypeEnum["MATISSE_GREEN"] = "MATISSE_GREEN";
    ChromogenTypeEnum["MATISSE_RED"] = "MATISSE_RED";
})(ChromogenTypeEnum || (ChromogenTypeEnum = {}));
export var getProbeAmps = function (ampCatalog, protocolType) {
    return uniqueBy(ampCatalog.proAmpConfigList.filter(function (c) {
        return c.platformCompatibility.find(function (pc) { return pc.id === (protocolType === null || protocolType === void 0 ? void 0 : protocolType.id); }) != null;
    }).map(function (c) {
        return {
            data: c.amplifier,
            channel: c.channelNum
        };
    }), function (amp) { return amp.data.id; })
        .sort(function (a1, a2) {
        return a1.channel - a2.channel;
    });
};
//# sourceMappingURL=EditKitForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/EditKitForm.js
// module id = 16
// module chunks = 0